import { SVGProps } from 'react';

const Gavel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14 13-8.381 8.38a2.122 2.122 0 1 1-3.001-3l8.384-8.381M16 16l6-6m-.5.5-8-8M8 8l6-6M8.5 7.5l8 8"
    />
  </svg>
);
export default Gavel;
